class Filters {
	constructor() {
		this.init();
	}

	init() {
		// Get the submit and refine filter elements
		const submitFilters = document.querySelector('.js-submit-filters');
		const refineFilters = document.querySelector('.js-refine-filters');

		// Attach event listeners if elements are found
		if (submitFilters) {
			// Bind the 'this' context to the event handler
			submitFilters.addEventListener('click', this.handleFiltersSubmit.bind(this));
		}

		if (refineFilters) {
			// Bind the 'this' context to the event handler
			refineFilters.addEventListener('change', this.handleRefineChange.bind(this));
		}
	}

	handleFiltersSubmit(e) {
		// Extract data-types attribute value from the clicked element
		const types = (e.currentTarget.getAttribute('data-types') || '').split(',');
		const data = {};

		// Loop through types and selected inputs to collect filter data
		types.forEach(function(value) {
			const inputs = document.querySelectorAll(`input[name="${value}"]:checked`);
			inputs.forEach(function(input) {
				const name = input.getAttribute('name') || '';
				data[name] = data[name] || [];
				data[name].push(input.getAttribute('value') || '');
			});
		});

		const url = window.location.href;
		const refineIndex = url.indexOf('refine');

		// Check if 'refine' parameter exists in the URL
		if (refineIndex > -1) {
			const refine = url.substring(refineIndex + 7).split('&')[0];
			data['refine'] = [refine];
		}

		// Decide whether to reset filters or generate parameters
		if (Object.keys(data).length === 0) {
			this.resetFilters();
		} else {
			this.generateParams(data);
		}
	}

	handleRefineChange(e) {
		// Get the selected refine value
		const refine = e.currentTarget.value;
		let url = window.location.href;

		if (refine === '') {
			const refineIndex = url.indexOf('?refine');

			// Check if 'refine' parameter exists in the URL
			if (refineIndex > -1) {
				const params = url.substring(refineIndex + 7).split('&')[0];
				url = url.substring(0, refineIndex) + params;
				window.location.href = url;
			} else {
				this.resetFilters();
			}
		} else {
			const refineIndex = url.indexOf('refine');

			// Modify URL based on refine parameter presence
			if (refineIndex > -1) {
				url = url.replace(/refine=\w+/, `refine=${refine}`);
			} else {
				if (url.indexOf('?') > -1) {
					url = `${url}&refine=${refine}`;
				} else {
					url = `${url}?refine=${refine}`;
				}
			}

			window.location.href = url;
		}
	}

	generateParams(data) {
		// Get the base URL and construct parameters
		const url = window.location.href.split('?')[0];
		const params = Object.keys(data)
			.map(index => `${index}=${data[index].join(',')}`)
			.join('&');

		// Navigate to the new URL with parameters
		window.location.href = `${url}${params ? `?${params}` : ''}`;
	}

	resetFilters() {
		// Get the base URL and reset filters
		const url = window.location.href.split('?')[0];
		window.location.href = url;
	}
}

// Export Filters class (for ES6 modules)
export default Filters;
